export enum SocialNetworkKey {
    FACEBOOK = 'facebook',
    INSTAGRAM = 'instagram',
    LINKEDIN = 'linkedin',
    PINTEREST = 'pinterest',
    TIKTOK = 'tiktok',
    X = 'x',
    YOUTUBE = 'youtube',
}
